// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"67":"a67139e7","617":"78c8330f","966":"b3914386"}[chunkId] + ".js";
};